export default "__VITE_ASSET__DAzy3TXy__"